/* eslint-disable import/prefer-default-export */

import React, { PureComponent } from 'react';
import FullPageLoadingIndicator from '../FullPageLoadingIndicator';

const RichTextArea = React.lazy(() => import('./groups/RichTextAreaV2'));

class VerbRichTextEditor extends PureComponent {
    render() {
        return (
            <React.Suspense fallback={FullPageLoadingIndicator}>
                <RichTextArea {...this.props} />
            </React.Suspense>
        );
    }
}

export { VerbRichTextEditor };
